// These are render functions called directly, not components, so they have no props to validate.
/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import { Icon } from 'antd';

/**
 * Render functions for the small marks drawn on assignment bars. The hover popup shows the
 * same marks (with `inline`) next to the section each one stands for, so users can tell
 * them apart. Plain functions, not components, so shallow renders see the same markup.
 */
const inlineClass = inline => ({ 'rct9k-timebar-item__mark--inline': inline });

/** 'sent' when every notification is sent, 'failed' when any failed, else 'pending'. */
export const notificationStatus = (notifications) => {
  if (!notifications || !notifications.length) {
    return null;
  }
  if (notifications.every(n => n.status === 'S')) {
    return 'sent';
  }
  return notifications.some(n => n.status === 'F') ? 'failed' : 'pending';
};

export const NOTIFICATION_STATUS_WORDS = { sent: 'all sent', pending: 'pending', failed: 'failed' };

export const notificationDot = ({ notifications, inline }) => {
  const status = notificationStatus(notifications);
  return status ? (
    <span className={classNames('rct9k-timebar-item__dot', inlineClass(inline), {
      green: status === 'sent',
      orange: status === 'pending'
    })}
    />
  ) : null;
};

export const signOnTriangle = ({ set, inline }) => (
  <svg
    className={classNames('rct9k-timebar-item__sign-on', inlineClass(inline), { set })}
    width="8"
    height="7"
    viewBox="0 0 8 7"
    aria-hidden="true"
  >
    <polygon points="4,0.5 7.5,6.5 0.5,6.5" />
  </svg>
);

export const notesDot = ({ admin, inline } = {}) => (
  <span className={classNames('rct9k-timebar-item__indicator', inlineClass(inline), { admin })} />
);

export const validationIcon = ({ inline } = {}) => (
  <span className={classNames('rct9k-timebar-item__validations', inlineClass(inline))}>
    <Icon type="warning" theme="filled" style={{ fontSize: '12px' }} />
  </span>
);

export const actionDot = ({ resolved, inline }) => (
  <span className={classNames('rct9k-timebar-item__action', inlineClass(inline), { resolved })} />
);
